<template>
  <div class="month-picker-button">
    <button type="button" class="month-trigger" :aria-label="ariaLabel" @click="togglePicker">
      {{ label }}
    </button>

    <div v-if="isOpen" class="month-panel">
      <div class="month-panel-head">
        <button type="button" class="nav-btn" aria-label="Année précédente" @click="displayYear -= 1">‹</button>
        <strong>{{ displayYear }}</strong>
        <button type="button" class="nav-btn" aria-label="Année suivante" @click="displayYear += 1">›</button>
      </div>

      <div class="month-grid">
        <button
          v-for="month in months"
          :key="month.value"
          type="button"
          class="month-option"
          :class="{ active: isSelected(month.value) }"
          @click="selectMonth(month.value)"
        >
          {{ month.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonthPickerButton',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: 'Choisir un mois',
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      isOpen: false,
      displayYear: new Date().getFullYear(),
      monthNames: [
        'Jan',
        'Fév',
        'Mar',
        'Avr',
        'Mai',
        'Juin',
        'Juil',
        'Août',
        'Sep',
        'Oct',
        'Nov',
        'Déc',
      ],
    };
  },
  computed: {
    label() {
      if (!this.modelValue) return this.ariaLabel;
      const [year, month] = this.modelValue.split('-').map(Number);
      if (!year || !month) return this.modelValue;
      return new Date(year, month - 1, 1).toLocaleDateString('fr-FR', {
        month: 'long',
        year: 'numeric',
      });
    },
    months() {
      return this.monthNames.map((label, index) => ({
        label,
        value: String(index + 1).padStart(2, '0'),
      }));
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        const year = Number(String(value || '').slice(0, 4));
        if (year) this.displayYear = year;
      },
    },
  },
  methods: {
    togglePicker() {
      this.isOpen = !this.isOpen;
    },
    isSelected(month) {
      return this.modelValue === `${this.displayYear}-${month}`;
    },
    selectMonth(month) {
      const value = `${this.displayYear}-${month}`;
      this.$emit('update:modelValue', value);
      this.$emit('change', { target: { value } });
      this.isOpen = false;
    },
  },
};
</script>

<style scoped>
.month-picker-button {
  position: relative;
  display: inline-flex;
  width: 100%;
  min-width: 150px;
  z-index: 30;
}

.month-trigger {
  width: 100%;
  min-height: 40px;
  border: 1px solid #d5deee;
  border-radius: 8px;
  background: #fff;
  color: #10213f;
  padding: 0 14px;
  font: inherit;
  font-size: 14px;
  font-weight: 800;
  text-align: left;
  text-transform: capitalize;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.month-trigger:hover {
  border-color: #2563eb;
  background: #f8fbff;
}

.month-trigger:focus-visible {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.14);
}

.month-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: min(300px, calc(100vw - 32px));
  border: 1px solid #d5deee;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.16);
  padding: 12px;
}

.month-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.month-panel-head strong {
  color: #10213f;
  font-size: 15px;
  font-weight: 900;
}

.nav-btn {
  width: 34px;
  height: 34px;
  border: 1px solid #d5deee;
  border-radius: 8px;
  background: #f8fafc;
  color: #10213f;
  font-size: 20px;
  cursor: pointer;
}

.nav-btn:hover {
  border-color: #2563eb;
  background: #eff6ff;
}

.month-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.month-option {
  min-height: 38px;
  border: 1px solid #d5deee;
  border-radius: 8px;
  background: #fff;
  color: #23395d;
  font: inherit;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.month-option:hover {
  border-color: #2563eb;
  background: #f8fbff;
}

.month-option.active {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
}
</style>
